/* eslint-disable react/no-array-index-key */
import React from "react";
import { useSelector } from "react-redux";
import DOMPurify from "dompurify";
import {
	CustomButton,
	CustomIconButton,
	I18nTranslate,
	IconComponent,
	UserAvatar,
	createNotification,
	icon,
} from "../../../../common/components";
import styles from "./ConversationBox.module.css";
import { translate } from "../../../../common/providers";
import aitendersWhiteLogo from "./images/aitendersWhiteLogo.svg";

const ConversationBox = ({ conversation, setIdChatAnswer, onOpenSidePanel }) => {
	const userInitials = useSelector(({ context }) => context.user ?? null);
	const handleCopyMessage = () => {
		const tempElement = document.createElement("div");
		tempElement.innerHTML = conversation.content;
		const table = tempElement.querySelector("table");
		if (!table) {
			navigator.clipboard
				.writeText(conversation.content)
				.then(() => {
					createNotification({
						type: "info",
						message: translate("ai-chat.conversation-box.notification-conversation-copied"),
					});
				})
				.catch((error) => {
					console.error("Failed to copy text: ", error);
				});
			return;
		}
		document.body.appendChild(tempElement);
		tempElement.style.position = "absolute";
		tempElement.style.left = "-9999px";
		const range = document.createRange();
		range.selectNode(table);
		window.getSelection().removeAllRanges();
		window.getSelection().addRange(range);
		try {
			document.execCommand("copy");
			createNotification({
				type: "info",
				message: translate("ai-chat.conversation-box.notification-conversation-copied"),
			});
		} catch (error) {
			console.error("Failed to copy text: ", error);
		}
		window.getSelection().removeAllRanges();
		document.body.removeChild(tempElement);
	};
	const handleOpenSourceSidePanel = () => {
		onOpenSidePanel(conversation.id);
		setIdChatAnswer(conversation.id);
	};
	function getTranslationKey(documentReferences, informationReferences) {
		if (documentReferences > 1 && informationReferences > 1) {
			return "ai-chat.conversation-box.display-button-name-contents-in-documents";
		}
		if (informationReferences > 1 && documentReferences === 1) {
			return "ai-chat.conversation-box.display-button-name-contents-in-document";
		}
		return "ai-chat.conversation-box.display-button-name-content-in-document";
	}
	return (
		<div className={styles.container}>
			<div className={styles.slot__left}>
				{conversation.owner === "system" && (
					<IconComponent autoTranslate="no" className={styles.conversation__icon}>
						<img
							alt="aitenders_logo"
							height="18px"
							src={aitendersWhiteLogo}
							style={{ marginBottom: "4px" }}
							width="22px"
						/>
					</IconComponent>
				)}
			</div>
			<div className={styles.content__container} data-user={conversation.owner !== "system"}>
				{conversation.content?.split("\n").map((line, index) => (
					// eslint-disable-next-line react/no-danger
					<div key={index} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(line) }} />
				))}
				{conversation.owner === "system" && (
					<div className={styles.response_actions}>
						<div className={styles.btn__container}>
							{(conversation.informationReferences && conversation.documentReferences && (
								<CustomButton variant="outlined" onClick={handleOpenSourceSidePanel}>
									{(conversation.informationReferences && conversation.documentReferences && (
										<I18nTranslate
											param={{
												documentReferences: conversation.documentReferences,
												informationReferences: conversation.informationReferences,
											}}
											translationKey={getTranslationKey(
												conversation.documentReferences,
												conversation.informationReferences
											)}
										/>
									)) ||
										null}
								</CustomButton>
							)) ||
								null}
						</div>
						<CustomIconButton
							className={styles.copyButton}
							data-testid="copy-response-button"
							icon={icon.faCopy}
							size="sm"
							variant="outlined"
							onClick={handleCopyMessage}
						/>
					</div>
				)}
			</div>
			<div className={styles.slot__right}>
				{conversation.owner !== "system" && (
					<UserAvatar
						isCurrentUser
						className={styles.user__icon}
						displayName={userInitials.displayName}
						email={userInitials.email}
						firstName={userInitials.firstName}
						lastName={userInitials.lastName}
						size="sm"
						userId={userInitials.id}
					/>
				)}
			</div>
		</div>
	);
};

export default ConversationBox;
